<script lang="ts">

import { ShoppingCart, User, ArrowLeft, ArrowUpRight } from '@lucide/svelte';
import { page } from '$app/state';
import { ORTHOHOUSE_URL, showsOrthoHouseLinks } from '$lib/utils/orthohouse';
import CartPopup from './CartPopup.svelte';
import { cartContainer } from '$lib/stores/Cart.svelte';
import {userContainer} from "$lib/stores/stores.svelte"
import {flip} from 'svelte/animate';
import {fade} from 'svelte/transition';
import Banner from './Banner.svelte';

  import { getLocale, setLocale, locales, localizeHref, deLocalizeHref } from "$lib/paraglide/runtime.js";
  import { m } from "$lib/paraglide/messages";
  import type { Action } from 'svelte/action';
  import { ChevronDown, Globe } from '@lucide/svelte';

  // Language display names and labels
  const LANGUAGE_LABELS: Record<string, { label: string; name: string }> = {
    en: { label: 'EN', name: 'English' },
    el: { label: 'ΕΛ', name: 'Ελληνικά' },
    ru: { label: 'RU', name: 'Русский' },
    he: { label: 'HE', name: 'עברית' },
  };

  const showParentLink = $derived(showsOrthoHouseLinks(page.url.pathname));

  let langMenuOpen = $state(false);
  let categoryMenuOpen = $state(false);

  // Detect current collection page for mobile nav
  function getCurrentCollection(): { name: string; key: 'shoes' | 'mats' } | null {
    if (typeof location === 'undefined') return null;
    const basePath = deLocalizeHref(location.pathname);
    if (basePath === '/shoes' || basePath.startsWith('/shoes/')) {
      return { name: m.shoes(), key: 'shoes' };
    }
    if (basePath === '/mats' || basePath.startsWith('/mats/')) {
      return { name: m.mats(), key: 'mats' };
    }
    return null;
  }

  let currentCollection = $state(getCurrentCollection());

  // Update on navigation
  $effect(() => {
    if (typeof window !== 'undefined') {
      currentCollection = getCurrentCollection();
    }
  });

const initSearch: Action = (e)=>{
  e.focus()
};

let searchText = $state("airo")

$effect(() => {
  console.log("searchText: "+$state.snapshot(searchText))
})





function isAtCartPage() {
  if (typeof location !== 'undefined') {
    const basePath = deLocalizeHref(location.pathname);
    return basePath === '/cart';
  }
  return false;
}

function mousOver(){
	console.log("mouseover")	
	userContainer.showingCartPopup = true
	userContainer.hideCartOverriden = true
}

function mouseLeave(){
	console.log("mouseleave")
	userContainer.hideCartOverriden = false
	// wait 1s before hiding the cart popup
	setTimeout(() => {
		if (!userContainer.hideCartOverriden) {
			userContainer.showingCartPopup = false
		}
	}, 500);
}


</script>
<!-- Parent-site entry at the foot of the category menus. Phones only: from md up the banner carries this link. -->
{#snippet orthoHouseMenuItem()}
  {#if showParentLink}
    <div class="md:hidden mt-1 border-t border-gray-200 pt-1 dark:border-gray-600">
      <a
        href={ORTHOHOUSE_URL}
        dir="auto"
        class="block px-4 py-2 text-start whitespace-normal hover:bg-gray-100 dark:hover:bg-gray-700"
        onclick={() => categoryMenuOpen = false}
      >
        <span class="flex items-center gap-1 text-sm font-medium text-gray-900 dark:text-gray-100">
          OrthoHouse
          <ArrowUpRight size={14} color="currentColor" class="shrink-0 rtl:-scale-x-100" aria-hidden="true" />
        </span>
        <span class="mt-0.5 block text-xs leading-snug text-gray-500 dark:text-gray-400">{m.orthohouse_tagline()}</span>
        <span class="sr-only">(orthohouse.com.cy)</span>
      </a>
    </div>
  {/if}
{/snippet}
<!-- Apply dark mode background and border -->
<header class="bg-white shadow-sm dark:bg-primary dark:border-b dark:border-gray-700">
<!-- <header class="bg-primary shadow-sm dark:bg-gray-900 dark:border-b dark:border-gray-700"> -->
    <div class="bg-secondary dark:bg-primary">
        <Banner/>
    </div>
    <!-- Top Bar: Logo, Search, Icons -->
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center h-20 desktop:h-24 justify-between">
        <!-- 1. Logo: auto width, flush left -->
        <div class="flex-shrink-0">
            
          <a href={localizeHref("/")} title="Healthy Shoes Home">
            <!-- Add filter for dark mode if logo needs inversion, e.g., dark:invert -->
            <enhanced:img
              class="h-14 w-auto desktop:h-16 dark:invert dark:brightness-0"
              src="/static/shoes_logo_text.png"
              alt="Healthy Shoes Logo"
              width="64"
              height="64"
            />
            <!-- Example for SVG logo that needs color change: -->
            <!-- <svg class="h-16 w-auto text-indigo-600 dark:text-indigo-400" ...> -->
          </a>
        </div>
  
        <!-- 2. Search: flex-grow to fill, center contents -->
       <!-- Search Bar with Results Dropdown -->
<div class="flex-grow flex items-center justify-center px-4 lg:px-12">
  <div class="relative w-full max-w-lg">
    <!-- Search Input -->
    <input
      class="block w-full appearance-none rounded-md border border-gray-300 bg-gray-100 px-4 py-2 pe-10 text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-indigo-500 sm:text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400 dark:focus:border-indigo-500 dark:focus:bg-gray-600 dark:focus:ring-indigo-500"
      type="search"
      name="search"
      bind:value={userContainer.searchText}
      use:initSearch
      onfocus="{()=>{
        if (userContainer.searchText.length > 0) {
          userContainer.showingSearch = true
        }
        }}"
      placeholder={m.search()}
      style="view-transition-name: search-input;"
    />

    <div class="pointer-events-none absolute inset-y-0 end-0 flex items-center pe-3">
      <!-- Search Icon SVG -->
      <svg class="h-5 w-5 text-gray-400 dark:text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
      </svg>
    </div>

  </div>
</div>
  
        <!-- 3. Icons: auto width, flush right, with fixed gap -->
        <div class="flex-shrink-0 flex items-center gap-4">
          <!-- Account Icon -->
          <a href={localizeHref("/account")} class="text-gray-600 hover:text-indigo-600 dark:text-white dark:hover:text-gray-300">
            <span class="sr-only">Account</span>
            <User/>
          </a>
  
          
  
          <!-- Cart Icon & Trigger -->
          <div
            class="relative"
            role="group"
            onmouseover={mousOver}
            onfocus={mousOver}
            onmouseleave={mouseLeave}
          >
            <a
              class="block text-gray-600 hover:text-indigo-600 dark:text-white dark:hover:text-gray-300"
              href={localizeHref("/cart")}
              aria-label="Shopping Cart"
            >
              <ShoppingCart/>
            </a>
            {#if cartContainer.cart?.lines.edges.length ?? 0 > 0}
              <span class="absolute -end-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-gray-700 text-xs font-medium text-white pointer-events-none">{cartContainer.cart!.lines.edges.length}</span>
            {/if}
            {#if userContainer.showingCartPopup && !isAtCartPage()}
              <div
                class="absolute top-full end-0 z-50 mt-2"
                role="dialog"
                aria-label="Shopping cart"
                transition:fade
              >
                <CartPopup />
              </div>
            {/if}
          </div>
        </div>
  
      </div>
    </div>
  
    <!-- Navigation Bar -->
    <nav class="bg-primary dark:bg-secondary">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex h-12 items-center justify-between">
          <!-- Left: Back button (when available) -->
          <div class="flex-1 flex items-center">
            {#if userContainer.prevPage != null}
              <button
                class="flex items-center gap-1 px-2 py-1.5 text-sm font-medium text-white hover:bg-secondary dark:hover:bg-primary rounded-md transition-colors"
                onclick={() => history.back()}
              >
                <ArrowLeft size={18} class="rtl:-scale-x-100" />
                <span class="hidden desktop:inline">{m.back?.() ?? 'Back'}</span>
              </button>
            {/if}
          </div>

          <!-- Center: Categories/Collection name and Find Us -->
          <div class="flex items-center justify-center gap-1 sm:gap-2 desktop:gap-6 whitespace-nowrap">
            <!-- Mobile: Show current collection name as dropdown (when on collection page) -->
            {#if currentCollection}
              <div class="relative desktop:hidden">
                <button
                  type="button"
                  class="flex items-center gap-0.5 px-1.5 py-1.5 text-sm font-medium text-white hover:bg-secondary dark:hover:bg-primary rounded-md transition-colors"
                  onclick={() => categoryMenuOpen = !categoryMenuOpen}
                  onblur={() => setTimeout(() => categoryMenuOpen = false, 150)}
                >
                  {currentCollection.name}
                  <ChevronDown size={16} class={categoryMenuOpen ? 'rotate-180 transition-transform' : 'transition-transform'} />
                </button>
                {#if categoryMenuOpen}
                  <div
                    class="absolute left-1/2 -translate-x-1/2 mt-1 w-56 md:w-40 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg z-50 py-1"
                    transition:fade={{ duration: 100 }}
                  >
                    <!-- Show other categories (not the current one) -->
                    {#if currentCollection.key !== 'shoes'}
                      <a
                        href={localizeHref("/shoes")}
                        class="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                        onclick={() => categoryMenuOpen = false}
                      >
                        {m.shoes()}
                      </a>
                    {/if}
                    {#if currentCollection.key !== 'mats'}
                      <a
                        href={localizeHref("/mats")}
                        class="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                        onclick={() => categoryMenuOpen = false}
                      >
                        {m.mats()}
                      </a>
                    {/if}
                    {@render orthoHouseMenuItem()}
                  </div>
                {/if}
              </div>
            {/if}

            <!-- Categories Dropdown (desktop always, mobile only when not on collection page) -->
            <div class="relative {currentCollection ? 'hidden desktop:block' : ''}">
              <button
                type="button"
                class="flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-3 py-1.5 sm:py-2 text-sm font-medium text-white hover:bg-secondary dark:hover:bg-primary rounded-md transition-colors"
                onclick={() => categoryMenuOpen = !categoryMenuOpen}
                onblur={() => setTimeout(() => categoryMenuOpen = false, 150)}
              >
                {m.categories?.() ?? 'Categories'}
                <ChevronDown size={16} class={categoryMenuOpen ? 'rotate-180 transition-transform' : 'transition-transform'} />
              </button>
              {#if categoryMenuOpen}
                <div
                  class="absolute left-1/2 -translate-x-1/2 mt-1 w-56 md:w-40 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg z-50 py-1"
                  transition:fade={{ duration: 100 }}
                >
                  <a
                    href={localizeHref("/shoes")}
                    class="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onclick={() => categoryMenuOpen = false}
                  >
                    {m.shoes()}
                  </a>
                  <a
                    href={localizeHref("/mats")}
                    class="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onclick={() => categoryMenuOpen = false}
                  >
                    {m.mats()}
                  </a>
                  {@render orthoHouseMenuItem()}
                </div>
              {/if}
            </div>

            <a
              href={localizeHref("/find-us")}
              class="px-1.5 sm:px-3 py-1.5 sm:py-2 text-sm font-medium text-white hover:bg-secondary dark:hover:bg-primary rounded-md transition-colors"
            >
              {m.find_us()}
            </a>
          </div>

          <!-- Right: Language picker -->
          <div class="flex-1 flex items-center justify-end">
            <div class="relative">
              <button
                type="button"
                class="flex items-center gap-1 px-2 py-1.5 text-sm font-medium text-white hover:bg-secondary dark:hover:bg-primary rounded-md transition-colors"
                onclick={() => langMenuOpen = !langMenuOpen}
                onblur={() => setTimeout(() => langMenuOpen = false, 150)}
              >
                <Globe size={16} />
                <span>{LANGUAGE_LABELS[getLocale()]?.label || 'EN'}</span>
                <ChevronDown size={14} class={langMenuOpen ? 'rotate-180 transition-transform' : 'transition-transform'} />
              </button>
              {#if langMenuOpen}
                <div
                  class="absolute end-0 mt-1 w-36 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg z-50 py-1"
                  transition:fade={{ duration: 100 }}
                >
                  {#each locales as locale}
                    <button
                      type="button"
                      class="w-full px-3 py-2 text-start text-sm hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-between
                        {getLocale() === locale ? 'bg-gray-50 dark:bg-gray-700 font-medium' : ''}"
                      onclick={() => { setLocale(locale); langMenuOpen = false; }}
                    >
                      <span class="text-gray-900 dark:text-gray-100">{LANGUAGE_LABELS[locale]?.name || locale}</span>
                      <span class="text-gray-500 dark:text-gray-400 text-xs">{LANGUAGE_LABELS[locale]?.label || locale.toUpperCase()}</span>
                    </button>
                  {/each}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>